/** "Journey" — what you've built: the coaching record and milestone
 *  timeline. (Profile reset lives in Settings, not here.) */

import { useQuery } from "@tanstack/react-query";

import { fetchProfileSummary } from "@/shared/api";
import { InvestmentHeader } from "@/features/skills/components/InvestmentHeader";
import { MilestoneTimeline } from "@/features/skills/components/MilestoneTimeline";

export function JourneyView() {
  const { data } = useQuery({ queryKey: ["profile-summary"], queryFn: fetchProfileSummary });

  const hasRecord = (data?.investment.daysActive ?? 0) > 0;
  const hasMilestones = (data?.milestones.length ?? 0) > 0;

  if (!hasRecord && !hasMilestones) {
    return (
      <div className="rounded-xl border border-border bg-surface p-8 text-center text-sm text-text-muted">
        Your record fills in as you drill: milestones, streaks, and the leaks
        you close all show up here.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <InvestmentHeader />
      <MilestoneTimeline />
    </div>
  );
}
